export default {
    ID: "1",
    SLUG: "enabill",
    NAME: "Enabill",
    PRIMARY: "#eb5b5e",
    SECONDARY: "#df2124",
    API: "https://api.enabill.com",
    LOGO: "/Assets/enabill/ena.png",
    APP_ICON: "/Assets/enabill/icon.png",
    APP_LOGO: "/Assets/enabill/logo.svg",
    APP_FAVICON: "/Assets/enabill/favicon.ico",
    APP_NAME: "Enabill",
  };